import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class DailyJobReportStore {
  loading = false;
  total = 0;
  detailedJobData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      detailedJobData: observable,
      tripData: observable,

      loadData: action,

      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    filterBy,
    driverId,
    status,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      driverId: driverId,
      filterBy: filterBy,
      status: status,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      pageNo: pageNo,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=delivery&a=getDailyJobReport",
        "postData=" + base64Input
      );

    this.detailedJobData = response?.data?.data?.data;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);
    window.location.href =
      baseURL +
      "index.php?c=delivery&a=exportDailyJobReportExcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&filterBy=" +
      getData.filterBy +
      "&did=" +
      getData.driverId +
      "&status=" +
      getData.status +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {
    window.location.href =
      baseURL +
      "index.php?c=delivery&a=exportDailyJobReportPdf&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&filterBy=" +
      getData.filterBy +
      "&did=" +
      getData.driverId +
      "&status=" +
      getData.status +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId=" +
      getData.userId +
      "&colList=" +
      getData.colList;
  }
}

export default DailyJobReportStore;
